import React from 'react';

interface GuestNameFieldsProps {
  firstName: string;
  lastName: string;
  onFirstNameChange: (value: string) => void;
  onLastNameChange: (value: string) => void;
  disabled?: boolean;
}

const GuestNameFields: React.FC<GuestNameFieldsProps> = ({
  firstName,
  lastName,
  onFirstNameChange,
  onLastNameChange,
  disabled = false,
}) => {
  return (
    <>
      <div className="form-group-modern">
        <label htmlFor="add-firstName">Prénom *</label>
        <input
          id="add-firstName"
          type="text"
          value={firstName}
          onChange={(e) => onFirstNameChange(e.target.value)}
          className="modal-input"
          placeholder="Prénom"
          autoFocus
          disabled={disabled}
        />
      </div>

      <div className="form-group-modern">
        <label htmlFor="add-lastName">Nom</label>
        <input
          id="add-lastName"
          type="text"
          value={lastName}
          onChange={(e) => onLastNameChange(e.target.value)}
          className="modal-input"
          placeholder="Nom (optionnel)"
          disabled={disabled}
        />
      </div>
    </>
  );
};

export default GuestNameFields;
